<template>
    <v-dialog v-model="dialog" width="800" :fullscreen="isMobileOrTablet()" persistent>
        <v-card class="rounded-lg" style="display: flex; flex-direction: column; height: 100%;">
            <v-card-title style="background-color: #1a5b0f !important; display: flex; justify-content: space-between; align-items: center;">
                <div>
                    <span class="font-weight-bold text-h6 text-white">{{ dialog_title }}</span>
                    <div class="text-caption text-white">{{ dialog_sub_title }}</div>
                </div>
                <v-btn v-if="loading == false" flat icon color="darkGreen" @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="overflow-y: auto; max-height: calc(100vh - 100px);">
                <v-form ref="form" class="mt-2">
                    <v-row dense>
                        <v-col cols="12">
                            <div class="text-red">Note: After changing the programs the assignees are reset, please proceed with caution.</div>
                        </v-col>
                        <v-col cols="12">
                            <v-autocomplete
                                v-model="department_arr"
                                :rules="[formRules.required]"
                                label="Programs of the Workload Preparators"
                                variant="outlined"
                                rounded="lg"
                                color="darkGreen"
                                :items="programData"
                                item-title="name"
                                item-value="id"
                                multiple
                                chips
                                >
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-3" style="margin-top: auto;">
                <v-spacer></v-spacer>
                <v-btn class="mr-1" :disabled="loading" text="Cancel" variant="outlined" elevation="1" @click="closeDialog()"></v-btn>
                <v-btn class="mr-1" :loading="loading" text="Save" variant="elevated" elevation="1" color="darkGreen" @click="validateForm()"></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { defineComponent } from 'vue'
import { useSnackbar } from '@/composables/useSnackbar'

export default defineComponent({
     emits: ["refresh"],
     data(){
        return {
            dialog: false,
            dialog_title: null,
            dialog_sub_title: null,
            action: null,
            loading: false,

            id: null,
            workloadData: null,
            programData: [],
            department_arr: [],
        }
     },
     methods: {
        initChange(data){
            this.dialog = true
            this.dialog_title = 'Change Programs of the Workload Preparators'
            this.dialog_sub_title = 'Please review and change the programs as necessary'
            this.action = 'add'

            this.workloadData = data
            this.department_arr = data.department_arr
            this.loadPrograms()
        },
        async loadPrograms(){
            this.loading = true
            const res = await this.axiosCall('/programs', 'get', null, false)
            if(res){
                this.programData = res.data
                this.loading = false
            }
        },
        async validateForm(){
            const { showSnackbar } = useSnackbar()
            const { valid } = await this.$refs.form.validate()

            if(valid){
                this.loading = true
                let formData = {
                    id: this.workloadData.id,
                    department_arr: this.department_arr
                }
                const res = await this.axiosCall('/faculty-workload/changeWorkloadPreparation', 'post', formData, true)
                if(res.data.status == 200){
                    this.loading = false
                    this.$emit('refresh')
                    showSnackbar('Workload Preparators Programs successfully changed!. Workload assignees have been reset.', 'success')
                    this.$refs.form.reset()
                    this.dialog = false
                }
            }
        },
        closeDialog(){
            this.$refs.form.reset()
            this.dialog = false
        }
     }
})
</script>

<style scoped>

</style>